import { render, staticRenderFns } from "./commentPersonList.vue?vue&type=template&id=33e46b44&scoped=true&lang=html&"
import script from "./commentPersonList.vue?vue&type=script&lang=js&"
export * from "./commentPersonList.vue?vue&type=script&lang=js&"
import style0 from "./commentPersonList.vue?vue&type=style&index=0&id=33e46b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e46b44",
  null
  
)

export default component.exports